import { useMemo, useCallback, useState, useEffect } from 'react';

export function useDropdownState({
  buckets,
  bucketValue,
  bucketPredicate,
  defaultOptions,
  defaultValue,
  filterKey,
  setFilters,
  queryKey=filterKey,
  updateQuery,
  isNumeric=true,
}) {
  let options = useDropdownOptions({ options: defaultOptions, buckets, bucketValue, bucketPredicate });
  let defaultOption = useDropdownDefaultOption({ options, defaultValue, isNumeric });

  let [ selected, setSelected ] = useState(defaultOption);

  let onSelect = useCallback((option) => setSelected(option && option.value !== `any` ? option : null), []);

  useEffect(() => {
    setFilters(x => {
      let newValue = selected?.values || selected?.value || null;

      if (x[filterKey] === newValue) return x;

      return { ...x, [filterKey]: newValue };
    });

    updateQuery({ [queryKey]: selected?.value });
  }, [selected]);

  return {
    options,
    selected,
    onSelect,
  };
}

function useDropdownOptions({ options, buckets, bucketValue, bucketPredicate }) {
  return useMemo(() => {
    if (buckets) {
      return bucketValue ? buckets.find(bucket => bucketPredicate(bucket, bucketValue)).options : buckets[0].options;
    }

    return options;
  }, [options, buckets, bucketValue, bucketPredicate]);
}

function useDropdownDefaultOption({ options, defaultValue, isNumeric }) {
  return useMemo(() => {
    if (!defaultValue || !options) return null;

    if (isNumeric) {
      defaultValue = parseFloat(defaultValue);
    }

    return options.find(x => x.value === defaultValue);
  }, []);
}
